
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 25","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_24243_5065)","stroke":"#E6E7E9","stroke-width":"1.714","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.279 3.115h2.571a1.714 1.714 0 011.715 1.715v17.143a1.714 1.714 0 01-1.715 1.714H5.136a1.714 1.714 0 01-1.714-1.714V4.83a1.714 1.714 0 011.714-1.715h2.572"}}),_c('path',{attrs:{"d":"M14.568 1.401H9.425c-.947 0-1.714.768-1.714 1.714v.858c0 .946.767 1.714 1.714 1.714h5.143c.947 0 1.714-.768 1.714-1.714v-.858c0-.946-.767-1.714-1.714-1.714zM7.71 9.972h8.572M7.71 14.258h8.572M7.71 18.544h8.572"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_24243_5065"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .545)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    